"use client"

import { ColumnDef } from "@tanstack/react-table"
import { ArrowUpDown } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import BeaconStoreRowActions from "./BeaconStoreRowActions"
import { format } from "date-fns"


export type BeaconStore = {
    id: string
    name: number
    slug: string
    description: number
    parent_id: number
    featured: string
    menu: string
    created_at: Date
    updated_at: Date
}
interface rowActionProps {
    onEdit: (data: any) => void;
    onDelete: (data: any) => void;
    roles: string[]
}
export const BeaconsStoreColumns = ({ onEdit, onDelete, roles }: rowActionProps): ColumnDef<BeaconStore>[] => {
    const columns: ColumnDef<BeaconStore>[] = [
        
        {
            accessorKey: "id",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Id
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                );
            },
        },
        {
            accessorKey: "name",
            header: "Name",
        },
        {
            accessorKey: "description",
            header: "Description",
        },
        {
            accessorKey: "created_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Created At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const created_at = row.original.created_at;
                const formattedDate = created_at ? format(new Date(created_at), 'yyyy-MM-dd HH:mm:ss') : "";

                return <span>{formattedDate}</span>;
            },
        },
        {
            accessorKey: "updated_at",
            header: ({ column }) => {
                return (
                    <Button
                        variant="ghost"
                        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
                    >
                        Updated At
                        <ArrowUpDown className="ml-2 h-4 w-4" />
                    </Button>
                )
            },
            cell: ({ row }) => {
                const updated_at = row.original.updated_at;
                const formattedDate = updated_at ? format(new Date(updated_at), 'yyyy-MM-dd HH:mm:ss') : "";
                return <span>{formattedDate ? formattedDate : ""}</span>
            },
        },

    ]

    if (roles.includes('beacon-store-delete') || roles.includes('beacon-store-edit')) {
        columns.push({
            id: "actions",
            header: 'Actions',
            cell: ({ row }) => <BeaconStoreRowActions row={row} onEdit={onEdit} onDelete={onDelete} roles={roles} />,
        })
    }

    return columns
};
